import React from 'react';

import {Button, Dropdown, Icon, Text, Toggle} from '@albert-io/atomic';

interface Props {
  showHidden: boolean;
  onToggle: (show: boolean) => void;
}

const TOGGLE_ID = 'subjects-show-hidden';

// Filters popover (Figma 4754-108788): a single "Show hidden subjects" switch with explanatory copy.
// Hidden subjects are no longer publicly available; surfacing them lets a teacher still manage access.
// Dropdown (not Menu) since the content is arbitrary — a toggle + paragraph, not an action list.
export const SubjectsFilterMenu = ({showHidden, onToggle}: Props) => (
  <Dropdown
    applyBorderBottomToChildren={false}
    position='bottom-end'
    positionFixed
    contentClassName='w-[391px] rounded-x2! p-x3! elevation-shadow-l2!'
    trigger={
      <Button color='secondary' variant='outlined' data-testid='subjects-filters'>
        <Icon className='mr-x1' color={showHidden ? 'brand' : undefined} icon='bars-filter' />
        <Text color={showHidden ? 'brand' : 'inherit'}>Filters</Text>
        {showHidden && (
          <span aria-hidden className='ml-x1 h-x1 w-x1 rounded-full background-brand' />
        )}
      </Button>
    }
  >
    <div className='flex items-start gap-x3'>
      <label className='flex flex-1 cursor-pointer flex-col gap-x0-half' htmlFor={TOGGLE_ID}>
        <Text>Show hidden subjects</Text>
        <Text color='tertiary' size='s'>
          Hidden subjects are no longer publicly accessible to teachers or students, but will
          continue to appear in any existing assignments and historical reporting data.
        </Text>
      </label>
      <Toggle id={TOGGLE_ID} checked={showHidden} onChange={() => onToggle(!showHidden)} />
    </div>
  </Dropdown>
);
